import * as React from 'react';
import { useState, useEffect } from 'react';
import { Row, Col, Input, Label, TabContent, TabPane, Nav, NavItem, NavLink, } from 'reactstrap';
import Page from '../Page';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { Afr, getSelectedAfr, updateVersionStateValue, generateLocalStateFromEventProperties, versionStateValue, updateTableFact, existFactsInTable, existFactsByFundGroup } from '../../redux/AfrSlice';
import { AccountEditorGridNoSubAccountBulk, IAccountEditorGridNoSubaccountsOptions } from '../core/AccountEditorGridNoSubAccountBulk'
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import utilityHelper from '../../utils/utilityHelper';
import enums from '../../utils/enums';




const BalanceSheetForFundsCore = (props: {
    userRole: string,
    state: any,
    fundGroup: string,
    setHasData: (hasData: boolean) => void,
    updateState: (newState: any) => void,
    noData: string,
    done: string
}) => {

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const ename = entity ? entity.name : "";
    const ecode = entity ? entity.code : "";
    const [activeTab, setActiveTab] = useState("2");
    const [hasFacts, setHasFacts] = useState(true);
    const [bsDocumentation, setBsDocumentation] = useState<string[]>([]);

    const isAdminUser: boolean = useAppSelector(isAdmin);
    /* ************************************** Redux ********************************************/
    const dispatch = useAppDispatch();

    const toggle = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            utilityHelper.saveDeferredChanges(dispatch);
        }
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }


    const currVersion = function () {
        if (currentAfr) {
            if (currentAfr.currentversion) {
                if (currentAfr.currentversion.versionState) {
                    return currentAfr.currentversion.versionState;
                }
            }
        }
        return null;
    }

    function noDataDisabled(noData: boolean) {
        if (hasFacts) {
            if (noData === false) {
                return true;
            }
        }
        return utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified);
    }

    // Cell Handler
    const handleCellEdited = function (cell: any) {
        var row = cell.getRow();
        var rowid = row.getData().accountCode;
        var conceptId = row.getData().accountId;
        var fieldid = cell.getField();
        var newvalue = cell.getValue();
        dispatch(updateTableFact(
            {
                tableId: "uas_006_balance-sheet",
                rowId: rowid,
                fundGroup: fieldid,
                concept: conceptId,
                value: newvalue
            }));

    }

    const handleChangeCheckbox = function (event: any) {

        var checkValues = JSON.parse(JSON.stringify(props.state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked
        checkValues[key] = value;


        // here call to dispatcher sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

        props.updateState(checkValues);

    }
    const setHasBSFacts = function (bHasFacts: boolean) {
        setHasFacts(bHasFacts);
        props.setHasData(bHasFacts);
    }

    useEffect(() => {
        if (!currentAfr) return;
        if (!currentAfr.currentversion) return;
        // get state from redux
        // enable/disable checkbox when there are (no) facts 
        var bHasFacts = existFactsByFundGroup(currentAfr, ["uas_006_balance-sheet", "uas_020_revenue", "uas_020_revenue_dwellings_and_fees", "uas_034_expenditures"], props.fundGroup);
        setHasFacts(bHasFacts);
        props.setHasData(bHasFacts);
        // create a local state from redux
    }, [currentAfr, currVersion(), props.state])

    const filteredEditorOptions = function (gname: string, start: string, end: string, exclude: string[]): IAccountEditorGridNoSubaccountsOptions {
        return {
            gridname: gname,
            cellEditHandler: handleCellEdited,
            doneFlag: props.done,
            noFlag: props.noData,
            fixedRows: false,
            dimensionColumn: null,
            firstFieldId: "FG_001_GeneralFundMember",
            allowedCombinations: null,
            accountRangeFilter: {
                first: start,
                last: end,
                exclude: exclude
            },
            accountGroups: null,
            columnFilter: props.fundGroup
        }
    }

    return (
        <React.Fragment>
            <Page>
                <Row>
                    <Col>
                        <div>
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('2')}
                                        onClick={() => { toggle('2'); }}
                                    >
                                        Assets
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('3')}
                                        onClick={() => { toggle('3'); }}
                                    >
                                        Deferred Outflows
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('4')}
                                        onClick={() => { toggle('4'); }}
                                    >
                                        Liabilities
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('5')}
                                        onClick={() => { toggle('5'); }}
                                    >
                                        Deferred Inflows
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('6')}
                                        onClick={() => { toggle('6'); }}
                                    >
                                        Fund Balances
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="2">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "2") && (
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName="uas_006_balance-sheet"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={[]}
                                                    options={filteredEditorOptions("assets", "101.000", "181.000", [])}
                                                    setHasData={setHasFacts}
                                                />)
                                            }
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="3">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "3") && (
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName="uas_006_balance-sheet"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={[]}
                                                    options={filteredEditorOptions("deferredoutflows", "190.000", "190.000", [])}
                                                    setHasData={setHasFacts}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="4">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "4") && (
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName="uas_006_balance-sheet"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={[]}
                                                    options={filteredEditorOptions("liabilities", "201.000", "273.000", [])}
                                                    setHasData={setHasFacts}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="5">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "5") && (
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName="uas_006_balance-sheet"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={[]}
                                                    options={filteredEditorOptions("deferredinflows", "290.000", "290.000", [])}
                                                    setHasData={setHasFacts}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="6">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "6") && (
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName="uas_006_balance-sheet"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={[]}
                                                    options={filteredEditorOptions("fundabalances", "274.000", "284.000", [])}
                                                    setHasData={setHasFacts}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                        </div>
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default BalanceSheetForFundsCore;